import React, { useState, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import Home from "../Page/Home/Home";
import Partycalldetails from "../Page/Partycalldetails/Partycalldetails";
import AllPartyCallTable from "../Page/Partycalldetails/Components/AllPartyCallTable";
import PartyCallDetailPage from "../Page/Partycalldetails/Components/PartyCallDetailPage";
import ComplaintDetailPage from "../Page/Partycalldetails/Components/ComplaintDetailPage";
import TaskMaster from "../Page/TaskMaster/TaskMaster";
import TaskMasterDetails from "../Page/TaskMaster/Components/TaskMasterDetails";
import SubTask from "../Page/SubTask/SubTask";
import ViewProfile from "../Page/ViewProfile/ViewProfile";
import AssignTask from "../Page/AssignTask/AssignTask";
import ShowAllTask from "../Page/ShowAllTask/ShowAllTask";
import AddMember from "../Page/AddMember/AddMember";
import ShowAllMember from "../Page/ShowAllMember/ShowAllMember";
import AddCustomer from "../Page/AddCustomer/AddCustomer";
import ShowAllCustomers from "../Page/ShowAllCustomers/ShowAllCustomers";
import DailyWork from "../Page/DailyWork/DailyWork";
import Payroll from "../Page/Payroll/Payroll";
import UpdateTaskForm from "../Page/TaskMaster/Components/UpdateTaskForm";
import EditSubTask from "../Page/SubTask/Components/EditSubTask";
import AssignTaskDetail from "../Page/AssignTask/Components/AssignTaskDetail";
import CustomerDetails from "../Page/ShowAllTask/Components/CustomerDetails";
import ShowMianTaskDetails from "../Page/ShowAllTask/Components/ShowMainTask/ShowMainTaskDetails";
import SubTaskInhouse from "../Page/SubTask/SubTaskInhouse";
import MainTask from "../Page/MainTask/MainTask";
import CustomerReq from "../Page/CustomerReq/CustomerReq";
import CustomerReqjunior from "../Page/CustomerReq/CustomerReqjunior";
import AddVersion from "../WhatsappPanelPage/Version/Add_Version";
import ShowVersion from "../WhatsappPanelPage/Version/ShowVersion";
import WhatsappLogReport from "../WhatsappPanelPage/WhatsappLogReport/WhatsappLogReport";
import ViewClient from "../WhatsappPanelPage/Client/ViewCleint";
import AddRegistration from "../WhatsappPanelPage/ExeRegistration/Add_Registration";
import ViewRegistration from "../WhatsappPanelPage/ExeRegistration/View_Registration";
import InhousePayroll from "../Page/Payroll/InhousePayroll";
import AttendanceAnalyticsDashboard from "../Page/Payroll/AttendanceAnalyticsDashboard/AttendanceAnalyticsDashboard";
import AddSlab from "../WhatsappPanelPage/Slab/Add_Slab";
import AddSlabDetail from "../WhatsappPanelPage/Slab/Add_Slab_Detail";
import Project from "../WhatsappPanelPage/Project/Project";
import AddTemplate from "../WhatsappPanelPage/Template/Add_Template";
import ViewTemplate from "../WhatsappPanelPage/Template/View_Template";
import WpSetupMain from "../WhatsappPanelPage/WhatsappApiSetup/Wp_Setup_Main";
import WpSetupDetails from "../WhatsappPanelPage/WhatsappApiSetup/Wp_Setup_Details";
import DocumentLinkMain from "../WhatsappPanelPage/DocumentLinkSetup/DocumentLink_main";
import DocumentLinkDetail from "../WhatsappPanelPage/DocumentLinkSetup/DocumentLinkDetail";
import WhatsAppRegistration from "../WhatsappPanelPage/WhatsAppRegistration/WhatsAppRegistration";
import ViewWpRegistration from "../WhatsappPanelPage/WhatsAppRegistration/View_WpRegistration";
import WhatsAppClientDetail from "../WhatsappPanelPage/WhatsAppRegistration/WhatsAppClientDetail";
import DataTransfer from "../WhatsappPanelPage/DataTransfer/DataTransfer";
import MemberDailyWork from "../Page/DailyWork/MemberDailyWork";
import AddPlan from "../GeminiOCR/OCRPlan";
import InwardLogs from "../GeminiOCR/InwardLogs";
import DeliveryLogs from "../GeminiOCR/DeliveryLogs";
import OCRAnalyticsDashboard from "../GeminiOCR/OCRAnalyticsDashboard";
import InhouseRnd from "../Page/CustomerReq/InhouseRnd";
import EmpProfile from "../Page/EmpProfile/EmpProfile";
import EmpDetail from "../Page/EmpProfile/EmpDetail";
import ExeUpdate from "../Page/DbExeUpdate/ExeUpdate";
import ExelUpdate from "../Page/DbExeUpdate/ExelUpdate";
import DbUpdate from "../Page/DbExeUpdate/DbUpdate";
import EmpOldDetails from "../Page/EmpOldDetails/EmpOldDetails";
import Report from "../Page/Report/Report";
import TaskReport from "../Page/TaskReport/TaskReport";
import TaskDetail from "../Page/TaskReport/TaskDetail";
import Projecttypemoduleanalysis from "../Page/projecttypemoduleanalysis/projecttypemoduleanalysis";
import MonthlyReport from "../Page/TaskReport/MonthlyReport";
import TaskTimeingReport from "../Page/TaskReport/TaskTimeingReport";
import LeaveForm from "../Page/LeaveForm/LeaveForm";
import PMRequest from "../Page/LeaveRequest/ProjectManager/PMRequest";
import GMRequest from "../Page/LeaveRequest/GeneralManager/GMRequest";
import { useSelector } from "react-redux";
import OwnerLeaveInbox from "../Page/LeaveRequest/OwnerInbox/OwnerInbox";
import MyRequest from "../Page/LeaveRequest/EmployeeRequest/MyRequest";
import Einvoice_Eway_Setup_Main from "../EINVOICE_EWAY BILL/Einvoice_Eway_Setup_Main/Einvoice_Eway_Setup_Main";
import Einvoice_Eway_Setup_Detail from "../EINVOICE_EWAY BILL/Einvoice_Eway_Setup_Detail/Einvoice_Eway_Setup_Detail";
import Einvoice_Eway_Setup_Registration from "../EINVOICE_EWAY BILL/Einvoice_Eway_Setup_Registration/Einvoice_Eway_Setup_Registration";
import SignCopyRcv from "../GeminiOCR/SignCopyRcv";
import GstIn_Setup from "../EINVOICE_EWAY BILL/GstIn Setup/GstIn_Setup";
import EInvoice_Eway_Log from "../EINVOICE_EWAY BILL/EInvoice_Eway Log/EInvoice_Eway Log";
import EInvoice_Eway_Response from "../EINVOICE_EWAY BILL/EInvoice_Eway Response/EInvoice_Eway_Response";
import EmployeeHistory from "../Page/LeaveRequest/Employee History/EmployeeHistory";
import MyAttendance from "../Page/LeaveRequest/MyAttendance/MyAttendance";
import MyCorrection from "../Page/LeaveRequest/MyCorrection/MyCorrection";
import AttendanceCorrections from "../Page/LeaveRequest/Attendance Corrections/AttendanceCorrections";
import ViewAllNotification from "../Components/ViewAllNotification/ViewAllNotification";
import GeoResolverSetup from "../WhatsappPanelPage/GeoResolver/GeoResolverSetup";
import OwnerChatManagement from "../Page/Chat/OwnerChatManagement";
import InternshipOfferLetter from "../EmployeeDocument/InternshipOfferLetter";
import InternshipCompletionLetter from "../EmployeeDocument/InternshipCompletionLetter";
import JobOfferLetter from "../EmployeeDocument/JobOfferLetter";
import BondTemplate from "../EmployeeDocument/BondTemplate";
import LoginActivity from "../Page/LoginActivity/LoginActivity";
import ProjectsMaster from "../Page/TableManagement/ProjectsMaster";
import TypeMaster from "../Page/TableManagement/TypeMaster";
import ModuleMaster from "../Page/TableManagement/ModuleMaster";
import TableMaster from "../Page/TableManagement/TableMaster";
const LockedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    sessionStorage.getItem("dspl_auth") === "true"
  );
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const handleUnlock = (e) => {
    e.preventDefault();
    if (password === "DSPL") {
      sessionStorage.setItem("dspl_auth", "true");
      setIsAuthenticated(true);
      setError(false);
    } else {
      setError(true);
    }
  };

  if (isAuthenticated) {
    return children;
  }

  return (
    <div style={{
      width: "100%",
      minHeight: "80vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem",
      boxSizing: "border-box"
    }}>
      <div style={{
        backgroundColor: "#ffffff",
        padding: "2.5rem",
        borderRadius: "1.5rem",
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
        border: "1px solid #e2e8f0",
        width: "100%",
        maxWidth: "400px",
        textAlign: "center",
        fontFamily: "Inter, sans-serif"
      }}>
        <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🔒</div>
        <h2 style={{ fontSize: "1.5rem", fontWeight: 800, color: "#1e293b", marginBottom: "0.5rem" }}>
          Secure Access Required
        </h2>
        <p style={{ fontSize: "0.875rem", color: "#64748b", marginBottom: "1.5rem" }}>
          Please enter the administrative passcode to view this page.
        </p>
        <form onSubmit={handleUnlock}>
          <input
            type="password"
            placeholder="Enter password..."
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError(false);
            }}
            style={{
              width: "100%",
              padding: "0.75rem 1rem",
              borderRadius: "0.75rem",
              border: error ? "2px solid #ef4444" : "1px solid #cbd5e1",
              fontSize: "0.875rem",
              color: "#1e293b",
              marginBottom: "1rem",
              outline: "none",
              textAlign: "center",
              boxSizing: "border-box"
            }}
            autoFocus
          />
          {error && (
            <p style={{ fontSize: "0.75rem", color: "#ef4444", fontWeight: 700, marginTop: "-0.5rem", marginBottom: "1rem" }}>
              Incorrect passcode. Please try again.
            </p>
          )}
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "0.75rem 1rem",
              borderRadius: "0.75rem",
              backgroundColor: "#4f46e5",
              color: "#ffffff",
              fontSize: "0.875rem",
              fontWeight: 700,
              border: "none",
              cursor: "pointer",
              transition: "all 0.2s"
            }}
          >
            Unlock Page
          </button>
        </form>
      </div>
    </div>
  );
};

const Routing = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/owner-chat") {
      sessionStorage.removeItem("dspl_auth");
    }
  }, [location.pathname]);

  const loginData = Cookies.get("loginData");
  const parsedData = loginData ? JSON.parse(loginData) : null; // Use null if loginData is undefined
  const { isdata } = useSelector((state) => state.auth);

  const isMain = isdata?.data?.IsMain;

  return (
    <>
      <Routes>
        <Route path="/login-activity" element={<LoginActivity />} />
        {parsedData?.data?.Role === "owner" ? (
          <>
            <Route path="/" element={<Home />} />
            <Route path="/partycalldetails" element={<Partycalldetails />} />
            <Route path="/partycalldetails/all" element={<AllPartyCallTable />} />
            <Route
              path="/partycalldetails/:id"
              element={<PartyCallDetailPage />}
            />
            <Route
              path="/partycalldetails/:id/:cid"
              element={<ComplaintDetailPage />}
            />
            <Route path="/DailyReport" element={<MemberDailyWork />} />
            <Route path="/TaskReport" element={<TaskReport />} />
            <Route path="/TaskDetail" element={<TaskDetail />} />
            <Route path="/MonthlyReport" element={<MonthlyReport />} />

            <Route
              path="/TaskReport/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route
              path="/ShowAllTask/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route
              path="/InhouseRnd/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />

            <Route path="/TaskTimeingReport" element={<TaskTimeingReport />} />


            <Route path="/taskmaster" element={<TaskMaster />} />
            <Route path="/taskmaster/:id" element={<TaskMasterDetails />} />
            <Route path="/taskmaster/update/:id" element={<UpdateTaskForm />} />
            <Route path="/subtask" element={<SubTask />} />
            <Route path="/subtask/editsubtask/:id" element={<EditSubTask />} />
            <Route path="/AssignTask" element={<AssignTask />} />
            <Route
              path="/projecttypemoduleanalysis"
              element={<Projecttypemoduleanalysis />}
            />

            {/* Table Management Master Pages */}
            <Route path="/ProjectsMaster" element={<ProjectsMaster />} />
            <Route path="/TypeMaster" element={<TypeMaster />} />
            <Route path="/ModuleMaster" element={<ModuleMaster />} />
            <Route path="/TableMaster" element={<TableMaster />} />
            <Route path="/CliendAdd" element={<TableMaster />} />

            <Route path="/OwnerLeaveInbox" element={<OwnerLeaveInbox />} />
            <Route path="/EmployeeHistory" element={<EmployeeHistory />} />
            <Route path="/AttendanceCorrections" element={<AttendanceCorrections />} />

            <Route path="/EmpProfile" element={<EmpProfile />} />
            <Route path="/employee/:id" element={<EmpDetail />} />
            <Route
              path="/AssignTask/TaskDetailsDetail/:id"
              element={<AssignTaskDetail />}
            />
            <Route path="/ShowAllTask" element={<ShowAllTask />} />

            <Route
              path="/ShowAllTask/TaskDetailsDetail/:id"
              element={<ShowMianTaskDetails />}
            />
            <Route path="/InhouseRnd" element={<InhouseRnd />} />

            <Route path="/AddMember" element={<AddMember />} />
            <Route path="/EmpOldDetails" element={<EmpOldDetails />} />
            <Route path="/ShowAllMember" element={<ShowAllMember />} />
            <Route path="/AddCustomer" element={<AddCustomer />} />
            <Route path="/ShowAllCustomers" element={<ShowAllCustomers />} />
            <Route path="/Payroll" element={<Payroll />} />
            <Route path="/AttendanceDashboard" element={<AttendanceAnalyticsDashboard />} />
            <Route path="/Report" element={<Report />} />
            <Route path="/owner-chat" element={<LockedRoute><OwnerChatManagement /></LockedRoute>} />

            {/* <Route path="/view-profile" element={<ViewProfile />} /> */}
            {/* <Route path="/Add_Client" element={<AddClient />} /> */}
            {/* ------------------------ Whatsapp Panel Start ------------------------ */}
            <Route path="/View_Client" element={<ViewClient />} />
            <Route
              path="/WhatsApp_Registration"
              element={<WhatsAppRegistration />}
            />
            <Route
              path="/View_WpRegistration"
              element={<ViewWpRegistration />}
            />
            <Route path="/WpSetupDetail" element={<WhatsAppClientDetail />} />
            <Route path="/Slab" element={<AddSlab />} />
            <Route path="/Slab_Detail" element={<AddSlabDetail />} />
            <Route path="/LogReport" element={<WhatsappLogReport />} />
            <Route path="/WpSetup_Main" element={<WpSetupMain />} />
            <Route path="/WpSetup_Details" element={<WpSetupDetails />} />
            <Route path="/DocumentLink_main" element={<DocumentLinkMain />} />
            <Route
              path="/DocumentLink_Details"
              element={<DocumentLinkDetail />}
            />
            <Route path="/DataTransfer" element={<DataTransfer />} />
            <Route path="/Add_Template" element={<AddTemplate />} />
            <Route path="/View_Template" element={<ViewTemplate />} />
            <Route path="/Project" element={<Project />} />
            <Route path="/Add_Registration" element={<AddRegistration />} />
            <Route path="/View_Registration" element={<ViewRegistration />} />
            <Route path="/Add_Version" element={<AddVersion />} />
            <Route path="/View_Version" element={<ShowVersion />} />

            {/* ------------------------ Whatsapp Panel End -------------------------- */}

            {/* ------------------------ Gemini OCR Start ------------------------ */}

            <Route path="/Ocr_Plan" element={<AddPlan />} />
            <Route path="/OCR_Dashboard" element={<OCRAnalyticsDashboard />} />
            <Route path="/OCR_Analytics" element={<OCRAnalyticsDashboard />} />
            <Route path="/Combined_Logs" element={<OCRAnalyticsDashboard />} />

            <Route path="/Inward_Logs" element={<InwardLogs />} />
            <Route path="/Delivery_Logs" element={<DeliveryLogs />} />

            <Route path="/SignCopyRcv" element={<SignCopyRcv />} />

            {/* ------------------------ Gemini OCR End ------------------------ */}

            {/* -------------------- Employee Document Start ---------------------- */}

            <Route
              path="/InternshipOfferLetter"
              element={<InternshipOfferLetter />}
            />
            <Route
              path="/InternshipCompletionLetter"
              element={<InternshipCompletionLetter />}
            />
            <Route path="/JobOfferLetter" element={<JobOfferLetter />} />
            <Route path="/Bond_template" element={<BondTemplate />} />

            {/* -------------------- Employee Document End ---------------------- */}

            {/* ------------------------ Db & Exe Upload Start ------------------------ */}

            <Route path="/DbUpdate" element={<DbUpdate />} />
            <Route path="/ExeUpdate" element={<ExeUpdate />} />
            <Route path="/ExelUpdate" element={<ExelUpdate />} />

            {/* ------------------------ Db & Exe Upload End ------------------------ */}

            {/* ------------------------ Einvoice & Eway Bill Start ------------------------ */}

            <Route path="/Einvoice_Eway_Setup_Main" element={<Einvoice_Eway_Setup_Main />} />
            <Route path="/Einvoice_Eway_Setup_Details" element={<Einvoice_Eway_Setup_Detail />} />
            <Route path="/Einvoice_Eway_Setup_Registration" element={<Einvoice_Eway_Setup_Registration />} />
            <Route path="/EInvoice_Eway_Log" element={<EInvoice_Eway_Log />} />
            <Route path="/EInvoice_Eway_Response" element={<EInvoice_Eway_Response />} />
            <Route path="/GstIn_Setup" element={<GstIn_Setup />} />

            {/* ------------------------ Einvoice & Eway Bill End ------------------------ */}

            {/* ------------------------ Notification Start ------------------------ */}

            <Route path="/notification" element={<ViewAllNotification />} />

            {/* ------------------------ Notification End ------------------------ */}

            {/* ------------------------ GeoResolver Start ------------------------ */}

            <Route path="/GeoResolver_Setup" element={<GeoResolverSetup />} />

            {/* ------------------------ GeoResolver End ------------------------ */}

            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) : parsedData?.data?.Role === "Web Junior Developer" ||
          parsedData?.data?.Role === "Delphi Junior Developer" ? (
          <>
            <Route path="/" element={<MainTask />} />
            <Route
              path="/TaskDetailsDetail/:id"
              element={<ShowMianTaskDetails />}
            />
            <Route path="/SubTask" element={<SubTaskInhouse />} />
            <Route path="/CustomerReq" element={<CustomerReqjunior />} />
            <Route
              path="/CustomerReq/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route path="/DailyWork" element={<DailyWork />} />

            <Route path="/Payroll" element={<InhousePayroll />} />

            <Route path="/LeaveRequest" element={<LeaveForm />} />

            <Route path="/MyRequest" element={<MyRequest />} />

            <Route path="/MyAttendance" element={<MyAttendance />} />

            <Route path="/MyCorrection" element={<MyCorrection />} />

            <Route path="/view-profile" element={<ViewProfile />} />

            {/* ------------------------ Notification Start ------------------------ */}

            <Route path="/notification" element={<ViewAllNotification />} />

            {/* ------------------------ Notification End ------------------------ */}


            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) : parsedData?.data?.Role === "Web Senior Developer" ||
          parsedData?.data?.Role === "Delphi Senior Developer" ? (
          <>
            <Route path="/" element={<Home />} />
            <Route path="/MainTask" element={<MainTask />} />
            <Route path="/SubTask" element={<SubTaskInhouse />} />
            <Route path="/CustomerReq" element={<CustomerReq />} />

            <Route path="/EmpProfile" element={<EmpProfile />} />
            <Route path="/employee/:id" element={<EmpDetail />} />

            <Route
              path="/CustomerReq/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route path="/InhouseRnd" element={<InhouseRnd />} />
            <Route
              path="/InhouseRnd/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />

            <Route
              path="/TaskReport/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route
              path="/ShowAllTask/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route
              path="/InhouseRnd/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route
              path="/AssignTask/TaskDetailsDetail/:id"
              element={<AssignTaskDetail />}
            />
            <Route path="/DailyReport" element={<MemberDailyWork />} />
            <Route path="/TaskReport" element={<TaskReport />} />
            <Route path="/TaskDetail" element={<TaskDetail />} />
            <Route path="/MonthlyReport" element={<MonthlyReport />} />
            <Route path="/taskmaster" element={<TaskMaster />} />
            <Route path="/taskmaster/:id" element={<TaskMasterDetails />} />
            <Route path="/taskmaster/update/:id" element={<UpdateTaskForm />} />
            <Route path="/AssignTask" element={<AssignTask />} />
            <Route path="/ShowAllTask" element={<ShowAllTask />} />
            <Route
              path="/ShowAllTask/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route
              path="/ShowAllTask/TaskDetailsDetail/:id"
              element={<ShowMianTaskDetails />}
            />
            <Route path="/AddMember" element={<AddMember />} />
            <Route path="/ShowAllMember" element={<ShowAllMember />} />
            <Route path="/subtaskmaster" element={<SubTask />} />
            <Route path="/subtask/editsubtask/:id" element={<EditSubTask />} />
            <Route path="/task-profile/:id" element={<ViewProfile />} />
            <Route path="/AddCustomer" element={<AddCustomer />} />
            <Route path="/ShowAllCustomers" element={<ShowAllCustomers />} />
            <Route path="/Payroll" element={<InhousePayroll />} />
            <Route path="/AttendanceDashboard" element={<AttendanceAnalyticsDashboard />} />
            {/* <Route path="/view-profile" element={<ViewProfile />} /> */}
            <Route path="/Report" element={<Report />} />



            {
              isMain === true ? (
                <Route path="/GeneralManagerRequest" element={<GMRequest />} />
              ) : (
                <Route path="/ProjectManagerRequest" element={<PMRequest />} />
              )
            }

            {/* ------------------------ Whatsapp Panel Start ------------------------ */}
            <Route path="/View_Client" element={<ViewClient />} />
            <Route
              path="/WhatsApp_Registration"
              element={<WhatsAppRegistration />}
            />
            <Route
              path="/View_WpRegistration"
              element={<ViewWpRegistration />}
            />
            <Route path="/WpSetupDetail" element={<WhatsAppClientDetail />} />
            <Route path="/Slab" element={<AddSlab />} />
            <Route path="/Slab_Detail" element={<AddSlabDetail />} />
            <Route path="/LogReport" element={<WhatsappLogReport />} />
            <Route path="/WpSetup_Main" element={<WpSetupMain />} />
            <Route path="/WpSetup_Details" element={<WpSetupDetails />} />
            <Route path="/DocumentLink_main" element={<DocumentLinkMain />} />
            <Route
              path="/DocumentLink_Details"
              element={<DocumentLinkDetail />}
            />
            <Route path="/DataTransfer" element={<DataTransfer />} />
            <Route path="/Add_Template" element={<AddTemplate />} />
            <Route path="/View_Template" element={<ViewTemplate />} />
            <Route path="/Project" element={<Project />} />
            <Route path="/Add_Registration" element={<AddRegistration />} />
            <Route path="/View_Registration" element={<ViewRegistration />} />
            <Route path="/Add_Version" element={<AddVersion />} />
            <Route path="/View_Version" element={<ShowVersion />} />
            {/* ------------------------ Whatsapp Panel End -------------------------- */}

            {/* ------------------------ Gemini OCR Start ------------------------ */}

            <Route path="/Ocr_Plan" element={<AddPlan />} />
            <Route path="/OCR_Dashboard" element={<OCRAnalyticsDashboard />} />
            <Route path="/OCR_Analytics" element={<OCRAnalyticsDashboard />} />
            <Route path="/Combined_Logs" element={<OCRAnalyticsDashboard />} />

            <Route path="/Inward_Logs" element={<InwardLogs />} />
            <Route path="/Delivery_Logs" element={<DeliveryLogs />} />
            <Route path="/SignCopyRcv" element={<SignCopyRcv />} />

            {/* ------------------------ Gemini OCR End ------------------------ */}

            {/* ------------------------ Db & Exe Upload Start ------------------------ */}

            <Route path="/DbUpdate" element={<DbUpdate />} />
            <Route path="/ExeUpdate" element={<ExeUpdate />} />
            <Route path="/ExelUpdate" element={<ExelUpdate />} />

            {/* ------------------------ Db & Exe Upload End ------------------------ */}

            {/* ------------------------ Einvoice & Eway Bill Start ------------------------ */}

            <Route path="/Einvoice_Eway_Setup_Main" element={<Einvoice_Eway_Setup_Main />} />
            <Route path="/Einvoice_Eway_Setup_Details" element={<Einvoice_Eway_Setup_Detail />} />
            <Route path="/Einvoice_Eway_Setup_Registration" element={<Einvoice_Eway_Setup_Registration />} />
            <Route path="/EInvoice_Eway_Log" element={<EInvoice_Eway_Log />} />
            <Route path="/EInvoice_Eway_Response" element={<EInvoice_Eway_Response />} />
            <Route path="/GstIn_Setup" element={<GstIn_Setup />} />

            {/* ------------------------ Einvoice & Eway Bill End ------------------------ */}

            {/* ------------------------ Notification Start ------------------------ */}

            <Route path="/notification" element={<ViewAllNotification />} />

            {/* ------------------------ Notification End ------------------------ */}

            {/* ------------------------ GeoResolver Start ------------------------ */}

            <Route path="/GeoResolver_Setup" element={<GeoResolverSetup />} />

            {/* ------------------------ GeoResolver End ------------------------ */}


            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) : parsedData?.data?.Role === "management" ? (
          <>
            <Route path="/" element={<Home />} />
            <Route path="/partycalldetails" element={<Partycalldetails />} />
            <Route path="/partycalldetails/all" element={<AllPartyCallTable />} />
            <Route
              path="/partycalldetails/:id"
              element={<PartyCallDetailPage />}
            />
            <Route
              path="/partycalldetails/:id/:cid"
              element={<ComplaintDetailPage />}
            />
            <Route path="/MainTask" element={<MainTask />} />
            <Route path="/SubTask" element={<SubTaskInhouse />} />
            <Route path="/CustomerReq" element={<CustomerReq />} />
            <Route
              path="/CustomerReq/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route path="/DailyWork" element={<DailyWork />} />
            <Route
              path="/AssignTask/TaskDetailsDetail/:id"
              element={<AssignTaskDetail />}
            />
            <Route path="/DailyReport" element={<MemberDailyWork />} />
            <Route path="/TaskReport" element={<TaskReport />} />
            <Route path="/TaskDetail" element={<TaskDetail />} />
            <Route path="/MonthlyReport" element={<MonthlyReport />} />
            <Route path="/taskmaster" element={<TaskMaster />} />
            <Route path="/taskmaster/:id" element={<TaskMasterDetails />} />
            <Route path="/taskmaster/update/:id" element={<UpdateTaskForm />} />
            <Route path="/AssignTask" element={<AssignTask />} />
            <Route path="/ShowAllTask" element={<ShowAllTask />} />
            <Route
              path="/ShowAllTask/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route
              path="/ShowAllTask/TaskDetailsDetail/:id"
              element={<ShowMianTaskDetails />}
            />

            <Route
              path="/TaskReport/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route
              path="/ShowAllTask/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route
              path="/InhouseRnd/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />

            <Route path="/AddMember" element={<AddMember />} />
            <Route path="/ShowAllMember" element={<ShowAllMember />} />
            <Route path="/subtaskmaster" element={<SubTask />} />
            <Route path="/subtask/editsubtask/:id" element={<EditSubTask />} />
            <Route path="/task-profile/:id" element={<ViewProfile />} />
            <Route path="/ShowAllCustomers" element={<ShowAllCustomers />} />
            <Route path="/Payroll" element={<InhousePayroll />} />
            <Route path="/AttendanceDashboard" element={<AttendanceAnalyticsDashboard />} />
            {/* <Route path="/view-profile" element={<ViewProfile />} /> */}
            <Route path="/Report" element={<Report />} />

            {/* Table Management Master Pages */}
            <Route path="/ProjectsMaster" element={<ProjectsMaster />} />
            <Route path="/TypeMaster" element={<TypeMaster />} />
            <Route path="/ModuleMaster" element={<ModuleMaster />} />
            <Route path="/TableMaster" element={<TableMaster />} />
            <Route path="/CliendAdd" element={<TableMaster />} />

            {/* ------------------------ Whatsapp Panel Start ------------------------ */}
            <Route path="/View_Client" element={<ViewClient />} />
            <Route
              path="/WhatsApp_Registration"
              element={<WhatsAppRegistration />}
            />
            <Route
              path="/View_WpRegistration"
              element={<ViewWpRegistration />}
            />
            <Route path="/WpSetupDetail" element={<WhatsAppClientDetail />} />
            <Route path="/Slab" element={<AddSlab />} />
            <Route path="/Slab_Detail" element={<AddSlabDetail />} />
            <Route path="/LogReport" element={<WhatsappLogReport />} />
            <Route path="/WpSetup_Main" element={<WpSetupMain />} />
            <Route path="/WpSetup_Details" element={<WpSetupDetails />} />
            <Route path="/DocumentLink_main" element={<DocumentLinkMain />} />
            <Route
              path="/DocumentLink_Details"
              element={<DocumentLinkDetail />}
            />
            <Route path="/DataTransfer" element={<DataTransfer />} />
            <Route path="/Add_Template" element={<AddTemplate />} />
            <Route path="/View_Template" element={<ViewTemplate />} />
            <Route path="/Project" element={<Project />} />
            <Route path="/Add_Registration" element={<AddRegistration />} />
            <Route path="/View_Registration" element={<ViewRegistration />} />
            <Route path="/Add_Version" element={<AddVersion />} />
            <Route path="/View_Version" element={<ShowVersion />} />
            {/* ------------------------ Whatsapp Panel End -------------------------- */}

            {/* ------------------------ Gemini OCR Start ------------------------ */}

            <Route path="/Ocr_Plan" element={<AddPlan />} />
            <Route path="/OCR_Dashboard" element={<OCRAnalyticsDashboard />} />
            <Route path="/OCR_Analytics" element={<OCRAnalyticsDashboard />} />
            <Route path="/Combined_Logs" element={<OCRAnalyticsDashboard />} />

            <Route path="/Inward_Logs" element={<InwardLogs />} />
            <Route path="/Delivery_Logs" element={<DeliveryLogs />} />
            <Route path="/SignCopyRcv" element={<SignCopyRcv />} />

            {/* ------------------------ Gemini OCR End ------------------------ */}

            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) : parsedData?.data?.Role === "Senior Customer Support" ? (
          <>
            <Route path="/" element={<MainTask />} />
            <Route
              path="/TaskDetailsDetail/:id"
              element={<ShowMianTaskDetails />}
            />
            <Route path="/SubTask" element={<SubTaskInhouse />} />
            <Route path="/CustomerReq" element={<CustomerReqjunior />} />
            <Route
              path="/CustomerReq/CustomerrequustDetail/:id"
              element={<CustomerDetails />}
            />
            <Route path="/DailyWork" element={<DailyWork />} />

            <Route path="/Payroll" element={<InhousePayroll />} />
            <Route path="/AttendanceDashboard" element={<AttendanceAnalyticsDashboard />} />
            <Route path="/ProjectManagerRequest" element={<PMRequest />} />

            <Route path="/view-profile" element={<ViewProfile />} />

            {/* ------------------------ Notification Start ------------------------ */}

            <Route path="/notification" element={<ViewAllNotification />} />

            {/* ------------------------ Notification End ------------------------ */}

            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) :
          (
            <>
              <Route path="/" element={<MainTask />} />
              <Route
                path="/TaskDetailsDetail/:id"
                element={<ShowMianTaskDetails />}
              />
              <Route path="/SubTask" element={<SubTaskInhouse />} />
              <Route path="/CustomerReq" element={<CustomerReqjunior />} />
              <Route
                path="/CustomerReq/CustomerrequustDetail/:id"
                element={<CustomerDetails />}
              />
              <Route path="/DailyWork" element={<DailyWork />} />

              <Route path="/Payroll" element={<InhousePayroll />} />

              <Route path="/LeaveRequest" element={<LeaveForm />} />

              <Route path="/MyRequest" element={<MyRequest />} />

              <Route path="/MyAttendance" element={<MyAttendance />} />

              <Route path="/MyCorrection" element={<MyCorrection />} />

              <Route path="/view-profile" element={<ViewProfile />} />

              {/* ------------------------ Notification Start ------------------------ */}

              <Route path="/notification" element={<ViewAllNotification />} />

              {/* ------------------------ Notification End ------------------------ */}

              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
      </Routes>
    </>
  );
};

export default Routing;
